import AnalyticsContainer from "./analytics.container";

export default AnalyticsContainer;
